import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'reportOptionsHowTo',
    templateUrl: './report-options-how-to.component.html',
    styleUrls: ['./report-options-how-to.component.css']

})

export class ReportOptionsHowToComponent implements OnInit, OnDestroy {

    thisDialogRef: MatDialogRef<ReportOptionsHowToComponent>;

    constructor(
        dialogRef: MatDialogRef<ReportOptionsHowToComponent>,
        private dialog: MatDialog,

    ) {
        this.thisDialogRef = dialogRef;

    } // end constructor


    ngOnInit() {

        // place holder
    }

    ngOnDestroy() {

    }


    closeClick() {
        this.thisDialogRef.close();
    }










}// end class